export const userGatewaysInfiniteScrollLimit = 25;

export enum USER_STATE {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export enum APPLICATION_NAMES {
  VITOGUIDE = 'Vitoguide',
}

export enum APPLICATION_ROLE_NAMES {
  INVITATION = 'Invitation',
}

export enum USER_DETAILS_ERROR_TYPES {
  GATEWAY_ERROR = 'GATEWAY_ERROR',
}

export interface GatewayViewModel {
  cursor: string;
  gateways: any[];
  isLoading: boolean;
  error: any;
}

export interface User {
  id: string;
  email: string;
  emailConfirmed: boolean;
  firstName: string;
  familyName: string;
  userState: USER_STATE;
}

export interface UserResponse {
  users: User[];
}
export interface UserValidity {
  from?: string;
  to?: string;
}

export interface UserProperty {
  name?: string;
  value?: string;
}

export interface UserProfile {
  userExtId: string;
  profileState: USER_STATE;
  unitExtId: string;
  name: string;
  isDefaultProfile: boolean;
  properties?: any[];
  _id: string;
}

export interface UserName {
  familyName?: string;
  firstName?: string;
}

export interface UserContact {
  telephone?: string;
  telefax?: string;
  mobile?: string;
  email?: string;
}

export interface UserAddress {
  addressline1?: string;
  addressline2?: string;
  postalCode?: string;
  city?: string;
  street?: string;
  houseNumber?: string;
  countryCode?: string;
  locality?: string;
  postOfficeBoxText?: string;
  postOfficeBoxNumber?: number;
  dwellingNumber?: number;
}

export interface Action {
  _fields?: Field[];
  _href?: string;
  _method?: string;
  _name?: string;
  _type?: string;
}

export interface Field {
  _name?: string;
  _type?: string;
  _value?: Value[];
}

export interface Value {
  _value?: string;
}

export interface UserRoles {
  applicationExtId: string;
  name: string;
  applicationName: string;
  _id: string;
}

export interface UserProfileProperties {
  name: string;
  value: boolean;
  scopeName: string;
}
